export function XrayOnboardingDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.ONBOARDING_WIZARD)
        .setCustomActions({
            'get': {
                method: 'GET'
            },
            'set': {
                method: 'POST'
            },
            'checkExternalConnection': {
                method: 'GET',
                path: '/system/external/ping'
            },
            'getMigrationStatus': {
                method: 'GET',
                path: '/migration?$no_spinner=true'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/onboarding_dao.js